import { useStore } from "zustand";
import { useFilterContext } from "./useFilterContext";
import { useCallback } from "react";
import { debounce } from "lodash";

export const useFiltersWithContext = () => {
  const { filterStore } = useFilterContext();

  const { filters, setFilter, deleteFilter, clearFilters } =
    useStore(filterStore);

  const getFilterValue = useCallback(
    (name: string, operator: string) => filters[name + operator]?.value,
    [filters],
  );

  const getFiltersWithName = useCallback(
    (name: string) =>
      Object.entries(filters).filter(([key]) => key.startsWith(name)),
    [filters],
  );

  const searchDebounced = useCallback(
    // eslint-disable-next-line react-compiler/react-compiler
    debounce((searchQuery) => {
      if (filters.searchTerm === searchQuery) return;

      if (searchQuery) {
        setFilter({
          field: "searchTerm",
          value: searchQuery,
          operator: "eq",
        });
      } else {
        deleteFilter("searchTerm", "eq");
      }
    }, 300),
    [setFilter],
  );

  return {
    filters,
    setFilter,
    deleteFilter,
    searchDebounced,
    getFilterValue,
    getFiltersWithName,
    clearFilters,
  };
};
